import { gql } from '@apollo/client';

export const CREATE_MEDIA_COMMENT = gql`
  mutation createMediaComment($input: CreateMediaCommentInput!) {
    createMediaComment(createMediaCommentInput: $input) {
      success
      error
      media {
        id
        comments {
          id
          body
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
